import React, { useEffect, useRef, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import { useAuth } from './APP/Context/AuthContext';
import Dashboard from './APP/Common_Component/Dashboard/Dashboard';
import Login from './Login/Login';
import { BrowserRouter as Router, Route, Routes, useNavigate, Navigate, useParams, BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ClientMaster from './APP/Common_Component/ClientMaster/ClientMaster';
import ProductKeyListMaster from './APP/Common_Component/ClientMaster/ProductKeyListMaster';
import ProductReport from './APP/Common_Component/Reports/ProductReport';

const App: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [isAuthorized, setIsAuthorized] = useState<boolean>(false);

  useEffect(() => {
    const isAuthorizeData = localStorage.getItem('isAuthorized');
    if (isAuthorizeData !== null) {
      setIsAuthorized(JSON.parse(isAuthorizeData).isAuthorized);
    }
  }, [isAuthenticated]);

  return (
    <>
      <div style={{ position: 'relative' }}>
        <div >
          {/* <Router> */}
            <Routes>
              <Route path="/" element={isAuthorized ? <Dashboard /> : <Login />} >
                <Route path="/ClientMaster" element={<ClientMaster />} />
                <Route path="/ClientMaster/productlist/:clientId" element={<ProductKeyListMaster />} />
                <Route path="/ProductReport" element={<ProductReport />} />
              </Route>
            </Routes>
            <ToastContainer position="top-center" style={{ zIndex: 1000000000000 }} />
          {/* </Router> */}
        </div>
      </div>
    </>
  );
};

export default App;
